import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "../Login.css";
import biswabangla from "../../../assets/images/biswabangla.png";
import { generateFCMToken } from "../../../firebase";

function MunicipalityLogin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [municipalityCode, setMunicipalityCode] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const device_id = await generateFCMToken();
    console.log("Device ID:", device_id);

    try {
      const response = await axios.post(
        "https://dev.sutmmg.codydeasoftech.in/api/login",
        {
          username: municipalityCode,
          password: password,
          fcm_token: device_id,
           device_type: "Web"
        }
      );




      if (response.data.status === true) {
        const { user,user_details, token } = response.data.data;


        if (user.user_type_id === 1 || user.user_type_id === 4) {
                Swal.fire({
                    title: "Login Failed",
                    text: "Wrong User ID or Password.",
                    icon: "error",
                    confirmButtonText: "OK",
                    allowOutsideClick: true,
                    allowEscapeKey: true
                });

                return;
                }



        Swal.fire({
          title: "Login Successful",
          text: response.data.message,
          icon: "success",
          timer: 1500,
          showConfirmButton: false
        });

        // Store session
        localStorage.setItem("token", token);
        localStorage.setItem("userId", user.user_id);
        localStorage.setItem("userTypeId", user.user_type_id);
        localStorage.setItem("username", user.username);
        localStorage.setItem("name", user.name);
        localStorage.setItem("districtId",user_details.district_id);

        // Municipality specific
        localStorage.setItem("municipality_id", user.user_id);

        setTimeout(() => {
          navigate("/app/dashboard");
        }, 1200);
      } else {
        Swal.fire("Login Failed", response.data.message, "error");
      }
    } catch (error) {

      Swal.fire(
        "Login Failed",
        error?.response?.data?.message || "Server error occurred.",
        "error"
      );
    }
  };


// const isIncognito = async () => {
//   try {
//     const fs = window.RequestFileSystem || window.webkitRequestFileSystem;
//     if (!fs) return false;

//     return new Promise((resolve) => {
//       fs(window.TEMPORARY, 100, () => resolve(false), () => resolve(true));
//     });
//   } catch {
//     return false;
//   }
// };




const detectIncognito = async () => {
  try {
    // Check storage quota
    const { quota } = await navigator.storage.estimate();
    if (quota && quota < 120000000) {
      return true;
    }

    // FileSystem API check (works mainly in Chrome)
    return await new Promise((resolve) => {
      const fs = window.RequestFileSystem || window.webkitRequestFileSystem;

      if (!fs) {
        resolve(false);
        return;
      }

      fs(
        window.TEMPORARY,
        100,
        () => resolve(false),
        () => resolve(true)
      );
    });
  } catch (e) {
    return false;
  }
};


// const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (loading) return;
//   setLoading(true);

//   try {

//     // 1️⃣ Detect Incognito
//     const isIncognito = await detectIncognito();
//     console.log("Incognito:", isIncognito);

//     if (isIncognito) {
//       Swal.fire({
//         title: "Incognito Mode Detected",
//         text: "Login is not allowed in Incognito/Private mode. Please open the site in normal browser mode.",
//         icon: "warning"
//       });
//       setLoading(false);
//       return;
//     }

//     // 2️⃣ Check notification permission
//     if (Notification.permission === "denied") {
//       Swal.fire({
//         title: "Notification Blocked",
//         text: "You have blocked notifications. Please enable them from browser settings to login.",
//         icon: "warning"
//       });
//       setLoading(false);
//       return;
//     }

//     console.log("Login clicked");

//     // 3️⃣ Generate FCM Token
//     const device_id = await generateFCMToken();
//     console.log("Device ID:", device_id);

//     // 4️⃣ Login API
//     const response = await axios.post(
//       "https://dev.sutmmg.codydeasoftech.in/api/login",
//       {
//         username: municipalityCode,
//         password: password,
//         fcm_token: device_id,
//         device_type: "Web"
//       }
//     );

//     if (response.data.status === true) {

//       const { user, user_details, token } = response.data.data;

//       // User type validation
//       if (user.user_type_id === 1) {
//         setLoading(false);
//         Swal.fire({
//           title: "Login Failed",
//           text: "Wrong User ID or Password.",
//           icon: "error"
//         });
//         return;
//       }

//       // Success message
//       Swal.fire({
//         title: "Login Successful",
//         text: response.data.message,
//         icon: "success",
//         timer: 1500,
//         showConfirmButton: false
//       });

//       // Save session
//       localStorage.setItem("token", token);
//       localStorage.setItem("userId", user.user_id);
//       localStorage.setItem("userTypeId", user.user_type_id);
//       localStorage.setItem("username", user.username);
//       localStorage.setItem("name", user.name);
//       localStorage.setItem("districtId", user_details.district_id);
//       localStorage.setItem("municipality_id", user.user_id);

//       // Redirect
//       setTimeout(() => {
//         navigate("/app/dashboard");
//       }, 1200);

//     } else {
//       Swal.fire("Login Failed", response.data.message, "error");
//     }

//   } catch (error) {

//     Swal.fire(
//       "Login Failed",
//       error?.response?.data?.message || "Server error occurred.",
//       "error"
//     );

//   } finally {
//     setLoading(false);
//   }
// };


return (
    <div className="login-container">
      <form className="login-card" onSubmit={handleSubmit}>
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <img src={biswabangla} alt="logo" style={{ width: "100px" , cursor: "pointer"  }} onClick={() => navigate("/landing")} />
          <h4 style={{ fontWeight: "bold" }}>
            {/* Urban School Uniform Stitching Project Management System */}

            Smart Urban Uniform Management System
          </h4>
          <p style={{ fontSize: "14px" }}>Sponsored by WB State Govt.</p>
                    <p className="fw-bold" style={{ fontSize: "20px", color: "#3e7ff6" }}>ULB LOGIN</p>

        </div>

        {/* MUNICIPALITY CODE */}
        <div className="input-wrapper">
          <span className="icon">
            <i className="fas fa-city"></i>
          </span>
          <input
            type="text"
            placeholder="Municipality Code"
            value={municipalityCode}
            onChange={(e) => setMunicipalityCode(e.target.value)}
            required
          />
        </div>

        {/* PASSWORD */}
        <div className="input-wrapper" style={{ position: "relative" }}>
          <span className="icon">
            <i className="fas fa-key"></i>
          </span>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <span
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
          >
            <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
          </span>
        </div>

        <button type="submit" disabled={loading}>
  {loading ? (
    <>
      <i className="fas fa-spinner fa-spin"></i> Logging in...
    </>
  ) : (
    "Login"
  )}
</button>
      </form>
    </div>
  );
}

export default MunicipalityLogin;
